module.exports = __webpack_public_path__ + "img/banner-intro.0cb203be.png";